import React, { useContext, useEffect } from "react";
import { Context } from "../../GAContext";
import { debounce } from "debounce";
import { CurrentPage } from "../../models";
import ReactGA from "react-ga4";
import PrimaryIcon from "./PrimaryIcon";
import { selectCategories, selectCurrentModule } from "../App/selectors";
import { selectLoadedUser } from "../../routes/Auth/auth.ducks";
import {
  selectFavoriteIds,
  selectFavorites,
  toggleFavorite
} from "../../routes/Favorite/favorite.ducks";
import { rootReducerInterface } from "../../typings/interfaces";
import { connect } from "react-redux";
import useHrPageName from "../../utils/useHrPageName";

const FavoriteButtonWhite = props => {
  const {
    className,
    ad,
    component: ComponentToRender,
    category,
    flag,
    disabled
  } = props;
  const [GaEvent] = useContext(Context);
  const hrPageName = useHrPageName(ad && ad.category, ad && ad.module);

  const debounced = debounce(
    () => {
      const { handleFavorite } = props;

      let label: string;
      let shouldSend = false;

      if (GaEvent == CurrentPage.home) {
        label = `Spremanje oglasa - najnoviji naslovnica ${hrPageName}`;
        shouldSend = true;
      }
      if (GaEvent == CurrentPage.search) {
        label = `Spremanje oglasa - rezultati pretrage ${hrPageName}`;
        shouldSend = true;
      }
      if (CurrentPage.details && flag == "SpecialSection") {
        label = `Spremanje oglasa - detalji oglasa ${hrPageName}`;
        shouldSend = true;
      }
      if (CurrentPage.details && flag == "SimilarAdsSection") {
        label = `Spremanje oglasa - slični oglasi ${hrPageName}`;
        shouldSend = true;
      }
      if (shouldSend) {
        ReactGA.event({
          category: "Spremanje oglasa",
          action: "Click",
          label: label
        });
      }
      handleFavorite();
    },
    1000,
    true
  );

  useEffect(() => {
    return () => {
      debounced.clear();
    };
  }, []);

  return (
    <ComponentToRender
      className={className}
      ad={ad}
      favoriteIds={props.favoriteIds}
      handleFavorite={
        disabled
          ? null
          : (e: any) => {
              e.preventDefault();
              debounced();
            }
      }
    />
  );
};

FavoriteButtonWhite.defaultProps = {
  component: PrimaryIcon,
  adLists: null,
  ad: null
};

function mapStateToProps(state: rootReducerInterface) {
  return {
    module: selectCurrentModule(state),
    user: selectLoadedUser(state),
    favoriteIds: selectFavoriteIds(state),
    favorites: selectFavorites(state),
    categories: selectCategories(state)
  };
}

function mergeProps(stateProps: any, dispatchProps: any, ownProps: any) {
  const { user, favoriteIds, favorites } = stateProps;
  const { ad, adLists } = ownProps;

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    handleFavorite() {
      dispatchProps.toggleFavorite(ad, favoriteIds, favorites, adLists, user);
    }
  };
}

const withConnect = connect(mapStateToProps, { toggleFavorite }, mergeProps);

export default withConnect(FavoriteButtonWhite);



// WEBPACK FOOTER //
// ./src/containers/FavoriteButtonWhite/index.tsx